import {
  Box,
  Backdrop,
  CircularProgress,
  Typography,
  useTheme,
} from "@mui/material"
import { MotionDiv, loadingLogo, loadingScreen } from "../motions"
import { Image } from "components/Image"
import { useTranslation } from "providers/i18n"

export const MapUpdatingScreen = (props) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { backdrop, container } =
    theme.components?.["MapUpdateLoadingScreen"].styleOverrides || {}
  return (
    <Backdrop {...props} sx={backdrop}>
      <Box sx={container}>
        <CircularProgress />
        <Typography>{t("Updating Map")}</Typography>
      </Box>
    </Backdrop>
  )
}

export const LoadingScreen = () => {
  const theme = useTheme()
  const { logo } = theme.assets || {}
  const styleOverrides = theme.components[`LoadingScreen`]?.styleOverrides || {}
  const { root, logo: logoStyle } = styleOverrides
  return (
    <MotionDiv
      key="loading"
      variants={loadingScreen}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <Box sx={root}>
        <MotionDiv key="logo" variants={loadingLogo} animate="animate">
          {logo && <Image src={logo.url} alt="Logo" sx={logoStyle} />}
        </MotionDiv>
      </Box>
    </MotionDiv>
  )
}
